import React, { useState } from 'react';
import { faBars, faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as Logo } from '../../svg/logo.svg';
import Menu from './Menu';
import styles from './Header.module.scss';

const Header: React.FC = () => {
  const [isMenuOpened, setMenuOpened] = useState<boolean>(false);

  const openMenu = () => {
    setMenuOpened(true);
  };

  const closeMenu = () => {
    setMenuOpened(false);
  };

  const OpenMenuButton = () => (
    <button type='button' className={styles.header__button_open} onClick={openMenu}>
      <FontAwesomeIcon icon={faBars} />
    </button>
  );

  const CloseMenuButton = () => (
    <button type='button' className={styles.header__button_close} onClick={closeMenu}>
      <FontAwesomeIcon icon={faTimes} />
    </button>
  );

  return (
    <header className={styles.header}>
      <h1 className={styles.header__title}>
        <Logo className={styles.header__logo} width='147' height='27' />
        カタログ
      </h1>
      {isMenuOpened ? <CloseMenuButton /> : <OpenMenuButton />}
      <Menu isOpen={isMenuOpened} close={closeMenu} />
    </header>
  );
};

export default Header;
